// extracted by mini-css-extract-plugin
module.exports = {"title":"Average_title__M3WGq","noDataContainer":"Average_noDataContainer__w5Tig"};